export default __webpack_public_path__ + "static/media/abBgGlow.06b57e0c.png";